/**
 * SourceTag — which tool a note came from, for NotesPage.jsx's list rows and
 * NoteDetail.jsx's header (My Notes rebuild, Stage 6). Keeps the two
 * existing, already-shipped treatments (Ask JAI's blue tag, Team Analyser's
 * warning-toned "Critical fix") exactly as they were, and extends the same
 * idea to the sources that didn't have one yet. 'manual' (a note typed
 * straight into the composer) renders nothing — there's no "source" to flag.
 */

import { V2, solidChip } from './JaiV2'

const SOURCE_META = {
  chat: { label: 'From Ask JAI', color: V2.blue },
  'team-analyser': { label: 'Critical fix', color: V2.warning },
  'player-analyser': { label: 'Player Analyser', color: V2.blue },
  'opponent-scout': { label: 'Opponent Scout', color: V2.blue },
  'trade-analyser': { label: 'Trade Analyser', color: V2.blue },
  'injury-insurance': { label: 'Injury Insurance', color: V2.error },
}

export default function SourceTag({ source }) {
  const meta = SOURCE_META[source]
  if (!meta) return null
  return (
    <span style={{
      fontSize: 9.5, fontWeight: 800, ...solidChip(meta.color),
      borderRadius: 5, padding: '2px 7px', letterSpacing: '0.06em',
      textTransform: 'uppercase', whiteSpace: 'nowrap',
    }}>
      {meta.label}
    </span>
  )
}
